// extracted by mini-css-extract-plugin
export default {"dataStatisticsBox":"dataStatistics_dataStatisticsBox__zU3G2","colBox":"dataStatistics_colBox__quREh","titleBox":"dataStatistics_titleBox__+NbkD"};